import React, {useState, useRef} from 'react';
import styled from 'styled-components';
import {v4 as uuid} from 'uuid';

import {toMap} from '../../lib/helpers';
import Input from '../Input';
import Card from '../Card';
import Popover from '../Popover';

function MultiSelectInput({values = [], options = [], onChange, ...props}) {
  const [isOpen, setOpen] = useState(false);
  const id = useRef(uuid());
  const optionsByKey = toMap(options, option => option.key);
  let value = values.map(key => optionsByKey[key].label).filter(Boolean).join(', ');

  if (values.length > 3) {
    value = `${values.length.toLocaleString()} items selected`;
  }

  return (
    <>
      <Input
        {...props}
        id={id.current}
        type="text"
        readOnly
        value={value}
        onFocus={() => setOpen(true)}
      />
      <Popover fullWidth open={isOpen} relativeTo={id.current} onClose={() => setOpen(false)}>
        <Options>
          {options.map(({key, label}) => (
            <Option key={key}>
              <input
                type="checkbox"
                checked={values.indexOf(key) >= 0}
                onChange={e => {
                  if (e.target.checked) {
                    onChange([...values, key]);
                  }
                  else {
                    onChange(values.filter(value => value !== key));
                  }
                }}
              />
              {label}
            </Option>
          ))}
        </Options>
      </Popover>
    </>
  );
}

const Options = styled(Card)`
  max-height: 12rem;
  overflow: auto;
  padding: 0.5rem 0;
`;

const Option = styled.label`
  display: block;
  padding: 0.5rem 1rem;

  input {
    margin-right: 0.5rem;
  }
`;

export default MultiSelectInput;